import { render, staticRenderFns } from "./ColorStrip.vue?vue&type=template&id=06638ed5&lang=pug&"
import script from "./ColorStrip.vue?vue&type=script&lang=js&"
export * from "./ColorStrip.vue?vue&type=script&lang=js&"
import style0 from "./ColorStrip.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports